import { render, staticRenderFns } from "./ListaFatture.vue?vue&type=template&id=05411428"
import script from "./ListaFatture.vue?vue&type=script&lang=js"
export * from "./ListaFatture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports